import React from 'react';
import { useCart } from '../context/CartContext';

const PaymentMethodSelection = () => {
  const { paymentMethod, dispatch } = useCart();
  const paymentOptions = [
    'Carte bancaire',
    'PayPal',
    'Virement',
  ];

  const handlePaymentChange = (event) => {
    dispatch({ type: 'SET_PAYMENT_METHOD', payload: event.target.value });
  };

  return (
    <div className="bg-white border border-slate-200 p-6 rounded-xl shadow-sm">
      <label htmlFor="payment" className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">
        Mode de paiement
      </label>
      <select 
        id="payment" 
        value={paymentMethod} 
        onChange={handlePaymentChange}
        className="w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-sm text-slate-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-none transition-all"
      >
        {paymentOptions.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PaymentMethodSelection;
